import { DraftAssessmentActivities } from 'approot/activity-builder/activity-builder-draft.constants';
import {
  ActivityBuilderIntroFooter,
  ActivityBuilderIntroHeader,
  ActivityBuilderIntroTitlePrint,
} from '../../introduction/activity-builder-intro';
import * as Styled from '../../introduction/activity-builder-intro.style';
import { getPrintImage } from 'approot/activity-builder/components/shared/logic/get-print-image';
import { useCsInSchool } from 'approot/shared/authors/authors.hooks';
import CsInSchoolsLogoPrint from 'approot/shared/authors/cs-in-schools-logo-print';
import { LANGUAGE_CODE_EN_AU, LanguageCodes } from 'global/constants';

const AssessmentBuilderIntroductionPrint = ({
  interactiveAssessment,
  language = LANGUAGE_CODE_EN_AU,
}: {
  interactiveAssessment: DraftAssessmentActivities;
  language?: LanguageCodes;
}) => {
  const assessment = interactiveAssessment?.assessment;
  const { isCsInSchoolsLesson } = useCsInSchool(assessment.authorId);

  return (
    <Styled.IntroSlidePrint
      $backgroundImage={getPrintImage(
        interactiveAssessment.landscapeImage?.responsive || null
      )}
    >
      <ActivityBuilderIntroHeader
        unitName={assessment.unit.name}
        contentName={assessment.name}
        contentLabel="Assessment"
      />
      <Styled.IntroBladePrint>
        <ActivityBuilderIntroTitlePrint
          richtext={interactiveAssessment?.assessmentName}
          logo={isCsInSchoolsLesson ? <CsInSchoolsLogoPrint /> : undefined}
        />
      </Styled.IntroBladePrint>
      <ActivityBuilderIntroFooter
        pageNumber={1}
        subject={assessment.subjects?.[0]?.label}
        showGoogleAttribution={language !== LANGUAGE_CODE_EN_AU}
      />
    </Styled.IntroSlidePrint>
  );
};

export default AssessmentBuilderIntroductionPrint;
